import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { CSSProperties } from "@material-ui/styles";
import { px } from "Configs/theme";
import { getColorRgbaFromHex } from "Helpers/ColorHelper";
import { DragElementWrapper } from "react-dnd";

interface Props {
	colorHex: string;
	drop: DragElementWrapper<any>;
	onClick: () => void;
	onMouseEnter: () => void;
	onMouseLeave: () => void;
	style: CSSProperties;
}

const DropAreaDroppableView: FC<Props> = (props) => {
	const classes = useStyles({ colorHex: props.colorHex });

	return (
		<div
			className={classes.dragElement}
			onMouseEnter={props.onMouseEnter}
			onMouseLeave={props.onMouseLeave}
			onClick={props.onClick}
			ref={props.drop}
			style={props.style}
			role="button"
		>
			{props.children}
		</div>
	);
};

export default DropAreaDroppableView;

interface StyleProps {
	colorHex: string;
}

const useStyles = makeStyles({
	dragElement: (props: StyleProps) => ({
		cursor: "pointer",
		overflow: "hidden",
		position: "absolute",
		top: 0,
		left: 0,
		boxSizing: "border-box",
		borderRadius: px.xs,
		alignItems: "center",
		justifyContent: "center",
		transition: "opacity 150ms ease, transform 300ms ease",
		backgroundColor: getColorRgbaFromHex(props.colorHex, 0.15),
		color: props.colorHex,
		border: `1px dashed ${props.colorHex}`,
	}),
});
